import { Injectable } from "@angular/core";
import { Road as RoadDto } from "src/app/proxy/roads/models";
import { Road } from "../../entities/road";
import { LocalDbService } from "../local-db-service";

@Injectable({ providedIn: 'root' })
export class RoadRepository {
  private get table() {
    return this.db.roadsTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Road[]> {
    const rows = await this.table.toArray();
    return this.mapRows(rows);
  }

  async getAllByProjectId(projectId: number): Promise<Road[]> {
    const rows = await this.table
      .where('projectId')
      .equals(projectId)
      .and(road => road.closed === false)
      .toArray();
    return this.mapRows(rows);
  }

  async getById(id: number): Promise<Road | undefined> {
    const row = await this.table.get(id);
    return row ? new Road(row) : undefined;
  }

  async upsertBulk(roads: Array<Road | RoadDto>): Promise<void> {
    if (roads.length === 0) {
      return;
    }

    const rows = roads.map(road => new Road(road));
    await this.table.bulkPut(rows);
  }

  async update(id: number, changes: Partial<Road>): Promise<void> {
    await this.table.update(id, changes);
  }

  async delete(id: number): Promise<void> {
    await this.table.delete(id);
  }

  async clear(): Promise<void> {
    await this.table.clear();
  }

  async getLatestLastProgressByProjectId(projectId: number): Promise<string | undefined> {
    const roads = await this.getAllByProjectId(projectId);

    return roads
      .filter(road => road.lastProgress)
      .sort((a, b) => new Date(b.lastProgress).getTime() - new Date(a.lastProgress).getTime())[0]
      ?.lastProgress;
  }

  private mapRows(rows: Road[]): Road[] {
    return rows.map(row => new Road(row));
  }
}
